import { ReactNode } from 'react';

import { AppFormattedMessage } from '../../../../../components/app-formatted-message/index';
import { getTranslation } from '../../../../../utils/get-translation.util';

export type ScenarioDetailsBase = {
  columns: (ReactNode | string)[];
  columnsCount: number;
  description: ReactNode | string;
  hoverText: ReactNode | string;
  showButton: boolean;
  title: ReactNode | string;
};
export interface NewScenarioDetails extends ScenarioDetailsBase {
  addButtonText: ReactNode | string;
}

export interface ExistingScenarioDetails extends ScenarioDetailsBase {
  additionalColumns?: (ReactNode | string)[];
  additionalColumnsCount?: number;
}

export enum LiquidityScenarioKey {
  CLASS_CONVERSION = 'liquidity-class-conversion',
  GRANTS = 'liquidity-grants',
  SAFES = 'liquidity-safes',
}

type ScenarioItem = {
  key: LiquidityScenarioKey;
} & (ExistingScenarioDetails | NewScenarioDetails);

export const liquidityScenarioItems: ScenarioItem[] = [
  {
    key: LiquidityScenarioKey.SAFES,
    description: getTranslation('AVAILABLE_SAFES'),
    hoverText: <AppFormattedMessage id="LIQUIDITY_SAFES_POPUP" />,
    title: <AppFormattedMessage id="SAFES" />,
    columns: [
      <AppFormattedMessage id="STAKEHOLDER" />,
      <AppFormattedMessage id="INVESTMENT" />,
      <AppFormattedMessage id="VAL_CAP" />,
      <AppFormattedMessage id="CAP_TYPE" />,
      <AppFormattedMessage id="DISC" />,
      <AppFormattedMessage id="FLOOR" />,
      <AppFormattedMessage id="MATURITY_DATE" />,
      <AppFormattedMessage id="SHARE_CLASS" />,
      <AppFormattedMessage id="PERCENT_OWNER_AT_CONVR" />,
      <AppFormattedMessage id="PERCENT_POST_ROUND" />,
      <AppFormattedMessage id="CONVERTED" />,
    ],
    columnsCount: 11,
    showButton: true,
  },
  {
    key: LiquidityScenarioKey.GRANTS,
    description: getTranslation('AVAILABLE_GRANTS'),
    hoverText: <AppFormattedMessage id="LIQUIDITY_GRANTS_POPUP" />,
    title: <AppFormattedMessage id="GRANTS" />,
    columns: [
      <AppFormattedMessage id="STAKEHOLDER" />,
      <AppFormattedMessage id="GRANT_ID" />,
      <AppFormattedMessage id="PLAN_TYPE" />,
      <AppFormattedMessage id="TOTAL_GRANTED" />,
      <AppFormattedMessage id="EXERCISED" />,
      <AppFormattedMessage id="EXERCISABLE" />,
      <AppFormattedMessage id="SHARE_CLASS" />,
      <AppFormattedMessage id="CONVERSION" />,
      <AppFormattedMessage id="NO_OF_SHARES" />,
    ],
    columnsCount: 9,
    showButton: false,
    additionalColumns: [
      <AppFormattedMessage id="STAKEHOLDER" />,
      <AppFormattedMessage id="GRANT_ID" />,
      <AppFormattedMessage id="TOTAL_GRANTED" />,
      <AppFormattedMessage id="EXERCISED" />,
      <AppFormattedMessage id="EXERCISABLE" />,
      <AppFormattedMessage id="SHARE_CLASS" />,
      <AppFormattedMessage id="CONVERSION" />,
      <AppFormattedMessage id="BASE_PRICE" />,
      <AppFormattedMessage id="PAYOUT" />,
      <AppFormattedMessage id="ISSUED_SHARES" />,
    ],
    additionalColumnsCount: 10,
  },
  {
    key: LiquidityScenarioKey.CLASS_CONVERSION,
    description: getTranslation('AVAILABLE_CLASS_CONVERSIONS'),
    hoverText: <AppFormattedMessage id="CLASS_CONVERSIONS_POPUP" />,
    title: <AppFormattedMessage id="CLASS_CONVERSIONS" />,
    columns: [
      <AppFormattedMessage id="STAKEHOLDER" />,
      <AppFormattedMessage id="SHARE_CLASS" />,
      <AppFormattedMessage id="PREFERRED_SHARES_COUNT" />,
      <AppFormattedMessage id="CONVERSION" />,
      <AppFormattedMessage id="NO_OF_SHARES" />,
    ],
    columnsCount: 8,
    showButton: true,
    additionalColumns: [
      <AppFormattedMessage id="STAKEHOLDER" />,
      <AppFormattedMessage id="SHARE_CLASS" />,
      <AppFormattedMessage id="PREFERRED_SHARES_COUNT" />,
      <AppFormattedMessage id="CONVERSION" />,
      <AppFormattedMessage id="NO_OF_SHARES" />,
    ],
    additionalColumnsCount: 9,
  },
];
